'use client'

import { DetailText } from 'design-configuration/components'
import { cn } from '@/lib/utils'
import { useState } from 'react'
import { AchievementFragment } from '@/gql/generated/graphql'
import { AchievementCommunityModal } from '.'

type CommunityTagProps = {
  achievement: AchievementFragment
  onClick?: () => void
  onDismiss?: () => void
  className?: string
}

export const CommunityTag = ({ achievement, onClick, onDismiss, className }: CommunityTagProps): React.ReactElement => {
  const [showCommunityModal, setShowCommunityModal] = useState(false)

  const handleOpenCommunity = () => {
    onClick?.()
    setShowCommunityModal(true)
  }

  const handleCloseCommunity = () => {
    setShowCommunityModal(false)
    onDismiss?.()
  }

  return (
    <>
      <button
        onClick={handleOpenCommunity}
        className={cn(
          'px-xs py-2xs border-outline-variant hover:border-outline text-on-surface-variant hover:text-on-surface rounded-full border transition-all focus:outline-none',
          className
        )}
      >
        <DetailText className="font-medium uppercase text-inherit">{achievement.name} Community</DetailText>
      </button>

      <AchievementCommunityModal show={showCommunityModal} onDismiss={handleCloseCommunity} achievement={achievement} />
    </>
  )
}
